import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import SelectOption from './SelectOption';
import styles from './SelectOptions.style';

class SelectOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [...props.options],
      errors: {},
    };
  }

  componentDidMount = () => this.setErrors();

  addOption = (index) => {
    const { options } = this.state;
    let newOptions = options.slice();
    newOptions.splice(index, 0, '');

    this.setState(
      {
        options: newOptions,
      },
      () => {
        this.setErrors();
        this.setFocus(index);
      },
    );
  };

  handleChange = (event, index) => {
    const { value } = event.target;
    let { errors, options } = this.state;

    options[index] = value;

    errors = { ...errors, ...this.invalidOptions(index) };
    this.setState({ options, errors });
  };

  handleKeyPress(event, index) {
    if (event.key === 'Enter') this.addOption(index + 1);

    if (this.deletionKey(event.keyCode) && event.target.value.length === 0) {
      this.deleteAtIndex(event, index);
    }
  }

  setFocus = (index) => document.getElementById(`option-${index}`).focus();

  onBlur = () => {
    const { options } = this.state;

    this.setErrors(() => {
      this.props.onChange(options);
    });
  };

  setErrors = (callback) => {
    this.setState(
      {
        errors: this.invalidOptions(),
      },
      () => callback && callback(),
    );
  };

  isValid(value, i) {
    const { options } = this.state;
    let otherOptions = [...options];
    otherOptions.splice(i, 1);

    return !otherOptions.includes(value);
  }

  invalidOptions = () => {
    let { options } = this.state;
    let errors = {};

    options.map((option, index) => {
      const otherIndex = options.indexOf(option);
      if (otherIndex > -1 && otherIndex !== index) {
        errors[index] = true;
        errors[otherIndex] = true;
      } else {
        errors[index] = false;
      }
    });

    return errors;
  };

  deletionKey = (keyCode) => [8, 46].indexOf(keyCode) > -1;

  deleteAtIndex = (event, index) => {
    event.target && event.target.blur();

    const { options } = this.state;
    let updatedOptions = [...options];
    updatedOptions.splice(index, 1);

    this.setState(
      {
        options: updatedOptions,
      },
      () => {
        this.setErrors();
        this.props.onChange(this.state.options);
      },
    );
  };

  onDragStart = ({ source }) => this.onBlur(null, source.index);

  onDragEnd = (result) => {
    if (!result.destination) return;

    const { options, onChange } = this.props;
    const updatedOptions = this.reorder(
      options,
      result.source.index,
      result.destination.index,
    );

    this.setState(
      {
        options: updatedOptions,
      },
      () => {
        onChange(this.state.options);
        this.setFocus(result.destination.index);
      },
    );
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  render() {
    const { classes } = this.props;
    const { options, errors } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.options}>
          <DragDropContext
            onDragStart={this.onDragStart}
            onDragEnd={this.onDragEnd}>
            <Droppable droppableId="optionsDroppable">
              {(provided) => (
                <div ref={provided.innerRef}>
                  {options.map((option, i) => (
                    <SelectOption
                      key={i}
                      option={option}
                      index={i}
                      error={errors[i] === true}
                      classes={classes}
                      onDelete={(event) => this.deleteAtIndex(event, i)}
                      handleChange={(event) => this.handleChange(event, i)}
                      handleKeyPress={(event) => this.handleKeyPress(event, i)}
                      onBlur={(event) => this.onBlur(event, i)}
                    />
                  ))}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div
          className={classes.add}
          onClick={() => this.addOption(options.length)}>
          <span>+ Add option</span>
        </div>
      </div>
    );
  }
}

SelectOptions.defaultProps = {
  options: [],
};

SelectOptions.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  classes: PropTypes.object,
};

export default withStyles(styles)(SelectOptions);
